<template>
  <div class="box-container">
    <iframe
      style="width: 100%; height: 800px"
      :src="url"
      allowfullscreen="allowfullscreen"
      frameborder="0"
      data-id="1"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      url: this.$config.env.VUE_APP_BRAND === "COTTI" ? this.$config.env.VUE_APP_DOWNLOAD + '/guide.html' : this.$config.env.VUE_APP_DOWNLOAD + '/guide_teacat.html'
    }
  }
}
</script>

<style scoped>
.box-container {
  margin-left: 20px;
  margin-right: 2px;
  padding-bottom: 24px;
  word-break: break-word;
}
</style>
